import React from 'react';
import './style/copyToClipboard.css';
import './style/shareComponent.css';
import CopyToClipboard from './copyToClipboard';
import { Button } from '../../../ui';
import { APIAction } from '../../../order-menu/api-action/api-action';
import Icon from '../../../jo-components/ui/icon/icon';
import HTMLContent from './../../../../components/htmlContent';
import Modal from '../../../jo-components/ui/modal/modal';

function ShareIcon({title, icon, url}){

    return (
        <div className='wz-share-icon' onClick={()=>window.open(url, "_blank")}>
            <Icon name={icon} size={'huge'}/>
            <span className='wz-share-title'>{title}</span>
        </div>
    )
}

export default function ShareComponent({data, onSubmit = () => {}}) {
    const [showModal, setShowModal] = React.useState(false);

    let share_action = React.useMemo(()=>{
        return data.actions.find(action => action.type === 'ShareResaleLinkStep')
    }, [data])

    let share_message_text = React.useMemo(()=>{
        if (!data.resale_option.share_message_text){
            return "";
        }
        return encodeURIComponent(data.resale_option.share_message_text)
    }, [data])

    let share_message_title = React.useMemo(()=>{
        if (!data.resale_option.share_message_title){
            return "";
        }
        return encodeURIComponent(data.resale_option.share_message_title)
    }, [data])

    
    const shareResale = React.useCallback(() => {
        onSubmit({
            data: {
                action: 'ShareResaleLinkStep'
            }
        })
    }, [onSubmit]);

    const onHide = React.useCallback(()=>{
        setShowModal(false);
    }, [])

    if (!data.resale_option.share_message_text || !data.resale_option.share_message_title){
        return null;
    }

    return (
        <div className='wz-copy-to-clipboard'>
            <Modal title={data.resale_option.share_title} subtitle={<HTMLContent content={data.resale_option.share_description}/>} open={showModal} onClose={onHide} >
                <CopyToClipboard data={data}/>
                <div className='wz-share-options'>
                    {share_action && share_action?.enabled && 
                        <APIAction name={'ShareResaleLinkStep'} actions={data.actions}>
                            <Button
                                className=''
                                label={share_action.label}
                                onClick={shareResale}
                            />
                        </APIAction>
                    }
                    
                    
                    <div className='wz-share-icons'> 
                        <ShareIcon title={"SMS"} icon={'sms'} url={`sms:?body=${share_message_text}`} />
                        <ShareIcon title={"Email"} icon={'sendMail'} url={`mailto:?subject=${share_message_title}&body=${share_message_text}`} />
                        <ShareIcon title={"WhatsApp"} icon={'whatsapp'} url={`https://wa.me/?text=${share_message_text}`} />
                        <ShareIcon title={"Telegram"} icon={'telegram'} url={`https://t.me/share/url?url=${share_message_title}&text=${share_message_text}`} />
                        {/* <ShareIcon title={"Messenger"} icon={'messenger'} url={`fb-messenger://share/?link=${share_message_text}`} /> */}
                    </div>

                </div>
            </Modal>

            <Icon name='share' onClick={()=>{
                setShowModal(true);
            }}/>
        </div>
    )
};